import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

export default function LatestSection() {
  const latestVideos = videos.filter((v) => v.isNew).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              最新更新
            </h2>
            <span className="px-2.5 py-0.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full">
              NEW
            </span>
          </div>
          <Link
            to="/category/dianshiju"
            className="text-sm text-foreground-500 hover:text-primary-500 transition-colors flex items-center gap-1 cursor-pointer"
          >
            全部新片
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {latestVideos.map((video) => (
            <Link
              key={video.id}
              to={`/detail/${video.id}`}
              className="group flex gap-3 p-3 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <div className="relative w-24 h-32 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={video.cover}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
              </div>
              <div className="flex flex-col justify-between py-1 min-w-0 flex-1">
                <div>
                  <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {video.title}
                  </h3>
                  <p className="text-xs text-foreground-400 mt-1">
                    {video.year} / {video.region}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-100 text-primary-700 rounded-md">
                    {video.category === 'dianshiju' ? '电视剧' : video.category === 'dianying' ? '电影' : video.category === 'dongman' ? '动漫' : video.category === 'zongyi' ? '综艺' : '纪录片'}
                  </span>
                  <span className="text-[10px] text-foreground-400">{video.updateInfo}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}